type ChapterAccess = { id: string; categoryId: string; complete: boolean; locked: boolean };

export const getCampaignAccess = (
  allChapters: readonly ChapterAccess[],
  categoryId?: string,
  chapterId?: string,
  selected?: readonly string[],
) => {
  const chapters = selected ? allChapters.filter((chapter) => selected.includes(chapter.categoryId)) : allChapters;
  if (chapters.length > 0 && chapters.every((chapter) => chapter.complete)) return 'campaign-complete';
  if (!categoryId) return 'available';
  const category = chapters.filter((chapter) => chapter.categoryId === categoryId);
  if (!category.length) return 'missing';
  if (category.every((chapter) => chapter.complete)) return 'category-complete';
  if (!chapterId) return 'available';
  const chapter = category.find((chapter) => chapter.id === chapterId);
  if (!chapter) return 'missing';
  if (chapter.complete) return 'chapter-complete';
  return chapter.locked ? 'locked' : 'available';
};
